function isValidDomain(str) {
    return /^(?!-)([A-Za-z0-9-]{1,63}\.)+[A-Za-z]{2,6}$/.test(str);
};

function isValidURL(str) {
    try {
        new URL(str);
        return true;
    } catch (_) {
        return false;
    }
};

function isValidEmail(str) {
    return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(str);
};

export {
    isValidDomain,
    isValidURL,
    isValidEmail
};
